// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-m_fl","advertDetailHeaderLocation__value":"c-m_fm"};